export default __webpack_public_path__ + "static/media/pic6.4cb1a394.jpg";